// ============================================================
// 生成 Schema（阶段一 T1）：常量与枚举
// 约定：只看"生成物可落库"的字段；与现有实体保持一一对应（详见施工图 §2）
// ============================================================

export const GENERATION_SCHEMA_VERSION = '1.0' as const;

/** 生成物类型（与施工图四份 Schema 对应） */
export const GENERATION_KINDS = ['scene', 'dashboard', 'fusion', 'dataflow'] as const;
export type GenerationKind = (typeof GENERATION_KINDS)[number];

/** 生成范围：scene=3D场景 dashboard=大屏 dataflow=数据集+规则（fusion 随 scene/dashboard 生成） */
export const GENERATION_SCOPES = ['scene', 'dashboard', 'dataflow'] as const;
export type GenerationScope = (typeof GENERATION_SCOPES)[number];

/** 基座/资产包类型（总方案 §4.3 的 12 类） */
export const ASSET_TYPES = [
  'base',
  'scene_template',
  'dashboard_template',
  'model_pack',
  'datasource_pack',
  'flow_pack',
  'rule_pack',
  'camera_pack',
  'theme_pack',
  'ai_prompt_pack',
  'fusion_pack',
  'delivery_pack',
] as const;
export type AssetType = (typeof ASSET_TYPES)[number];

export const BASE_TIERS = ['free', 'basic', 'pro', 'enterprise'] as const;
export type BaseTier = (typeof BASE_TIERS)[number];

export const BASE_VISIBILITIES = ['public', 'tenant', 'private'] as const;
export type BaseVisibility = (typeof BASE_VISIBILITIES)[number];

/** 场景数据绑定的视觉规则类型（scene_data_binding.visual_type） */
export const VISUAL_TYPES = ['device-link', 'color', 'animation', 'glow', 'label', 'height', 'transform'] as const;
export type VisualType = (typeof VISUAL_TYPES)[number];

/** 规则动作类型（rule.types.ts RULE_ACTION_TYPES 对齐） */
export const RULE_ACTION_TYPES = ['alert', 'webhook', 'command', 'broadcast'] as const;
export type RuleActionType = (typeof RULE_ACTION_TYPES)[number];

/** 规则条件算子白名单（json-rules-engine 标准算子） */
export const RULE_OPERATORS = [
  'equal',
  'notEqual',
  'greaterThan',
  'greaterThanInclusive',
  'lessThan',
  'lessThanInclusive',
  'in',
  'notIn',
  'contains',
  'doesNotContain',
] as const;
export type RuleOperator = (typeof RULE_OPERATORS)[number];

/** 数据集类型（data_sources.type 白名单） */
export const DATASET_TYPES = ['static', 'api', 'websocket', 'sql', 'mqtt'] as const;
export type DatasetType = (typeof DATASET_TYPES)[number];

/** 组件数据源类型白名单（V1 安全子集） */
export const WIDGET_DATASOURCE_TYPES = ['static', 'api', 'device', 'mqtt'] as const;
export type WidgetDataSourceType = (typeof WIDGET_DATASOURCE_TYPES)[number];

/** V1 体量上限（校验器与基座共用） */
export const GEN_LIMITS = {
  models: 30,
  components: 40,
  datasets: 10,
  flows: 20,
  bindings: 60,
} as const;
export type GenLimitKey = keyof typeof GEN_LIMITS;

/** V1 安全子集：data_sources.parser.filter 仅允许简单比较（禁函数调用与任意表达式） */
export const SIMPLE_FILTER_PATTERN = /^\s*(?:value|item\.value)\s*(?:>=|<=|==|!=|>|<)\s*-?\d+(?:\.\d+)?\s*$/;

/** 字段映射格式类型（DataFieldMapping.type 对齐） */
export const DATA_FIELD_MAPPING_TYPES = ['number', 'string', 'percent', 'thousand', 'date', 'jsonpath'] as const;
